import React from "react";

const ProductDemo = () => {
  return (
    <div
      style={{
        padding: "2rem 2rem",
        textAlign: "center",
      }}
    >
      {/* The iframe embeds your demo.html from the public folder */}
      <div
        style={{
          maxWidth: "2060px",
          margin: "0 auto",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 40px 120px rgba(0,0,0,0.5)",
          border: "1px solid rgba(255,255,255,0.15)",
        }}
      >
        <iframe
          src="/demo.html"
          title="How NORYQ Works"
          style={{
            width: "100%",
            height: "940px",
            border: "none",
            display: "block",
          }}
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default ProductDemo;
